import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import api from "../api/axios";
import { authReturnTo } from "../utils/authReturnTo";
import { isAuth0Enabled } from "./auth0Config";

function AuthTokenSync() {
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();

  useEffect(() => {
    if (!isAuth0Enabled || isLoading || !isAuthenticated) return undefined;

    let cancelled = false;

    const syncUser = async () => {
      const token = await getAccessTokenSilently();
      if (cancelled) return;

      localStorage.setItem("token", token);

      const { data } = await api.post("/auth/me");

      if (!cancelled && data?.user) {
        localStorage.setItem("user", JSON.stringify(data.user));
        const nextPath = authReturnTo(null, data.user.onboarding_completed ? "/feed" : "/onboarding");
        if (window.location.pathname !== nextPath) window.location.assign(nextPath);
      }
    };

    syncUser().catch(() => {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    });

    return () => {
      cancelled = true;
    };
  }, [getAccessTokenSilently, isAuthenticated, isLoading]);

  return null;
}

export default AuthTokenSync;
